import { render, staticRenderFns } from "./jilu.vue?vue&type=template&id=a6613652&scoped=true"
import script from "./jilu.vue?vue&type=script&lang=js"
export * from "./jilu.vue?vue&type=script&lang=js"
import style0 from "./jilu.vue?vue&type=style&index=0&id=a6613652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6613652",
  null
  
)

export default component.exports